import {AfterViewInit, Component, OnInit} from '@angular/core';
import {WorksService} from '../../services/works.service';
import {Work} from '../../models/work';
import {ScrollPositionService} from '../../services/scroll-position.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-work',
  templateUrl: './work-list.component.html',
  styleUrls: ['./work-list.component.css'],
})
export class WorkComponent implements OnInit, AfterViewInit {
  works: Work[] = [];
  loading: Boolean = true;

  constructor(private worksService: WorksService,
              private spService: ScrollPositionService) {
    worksService.works.subscribe((works) => {
      this.loading = false;
      this.works = works;
    });
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.spService.autoScroll();
  }

  scrollPastHero() {
    this.spService.scrollPastHero();
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/pages/work-list/work-list.component.ts